import LzMBase, { LzNBase } from './Base';

export interface LzNBackupRestore extends LzNBase {
  filename: string;
  datetime: string;
}

class LzMBackupRestore extends LzMBase implements LzNBackupRestore {
  filename: string;
  datetime: string;

  constructor(model?: LzNBackupRestore, copyAll?: boolean) {
    super(model, copyAll);

    this.filename = model?.filename || '';
    this.datetime = model?.datetime || '';
    this.filesize = +(model?.filesize || 0);
  }

}

export default LzMBackupRestore;
